export default {
  TensaoNominal: {
    label: 'fields.asset.circuit-breaker.nominal-tension',
    precision: 2,
  },
  CorrenteNominal: {
    label: 'fields.asset.circuit-breaker.nominal-chain',
    precision: 2,
  },
  FrequenciaNominal: {
    label: 'fields.asset.circuit-breaker.nominal-frequency',
    precision: 0,
  },
  TempoAberturaTipico: {
    label: 'fields.asset.circuit-breaker.opening-time',
    precision: 0,
  },
  TempoMaximoFechamento: {
    label: 'fields.asset.circuit-breaker.closing-time',
    precision: 0,
  },
  CapacidadeInterrupcaoNominal: {
    label: 'fields.asset.circuit-breaker.nominal',
    precision: 2,
  },
  TensaoNominalSuportavelAplicada: {
    label: 'fields.asset.circuit-breaker.applied-voltage',
    precision: 2,
  },
  TensaoNominalSuportavelFrequenciaIndustrial: {
    label: 'fields.asset.circuit-breaker.industrial-frequency',
    precision: 2,
  },
  TensaoNominalSuportavelImpulsoAtmosferico: {
    label: 'fields.asset.circuit-breaker.atmospheric-impulse',
    precision: 0,
  },
  CorrenteSuportavelCurtaDuracao: {
    label: 'fields.asset.circuit-breaker.short-duration-chain',
    precision: 0,
  },
  SequenciaNominalOperacao: {
    label: 'fields.asset.circuit-breaker.nominal-sequence-operation',
    precision: 0,
  },
  HistoricoManutencao: {
    label: 'fields.asset.maintenance-history',
    precision: 0,
  },
  Observacoes: {
    label: 'fields.general.observations',
    precision: 0,
  },
  PotenciaNominal: {
    label: 'fields.asset.transformer.nominal-potency',
    precision: 2,
  },
  ExpectativaVida: {
    label: 'fields.asset.transformer.life-expectancy',
    precision: 0,
  },
  CorrenteMinimaEstadoLigado: {
    label: 'fields.asset.transformer.minimum-chain-to-determine-on-state',
    precision: 2,
  },
  CorrenteNominalInferior: {
    label: 'fields.asset.transformer.nominal-chain-lower',
    precision: 2,
  },
  CorrenteNominalSuperior: {
    label: 'fields.asset.transformer.nominal-chain-higher',
    precision: 2,
  },
  CorrenteNominalTerciaria: {
    label: 'fields.asset.transformer.nominal-chain-tertiary',
    precision: 2,
  },
  EnrolamentoComTerciario: {
    label: 'fields.asset.transformer.has-windings',
  },
  QuantidadeEnrolamentoMonitorados: {
    label: 'fields.asset.transformer.number-of-monitored-windings',
  },
  TipoTransformador: {
    label: 'fields.general.type',
  },
  TensaoInferior: {
    label: 'fields.asset.transformer.lower-voltage',
    precision: 2,
  },
  TensaoSuperior: {
    label: 'fields.asset.transformer.higher-voltage',
    precision: 2,
  },
  TensaoTerciaria: {
    label: 'fields.asset.transformer.tertiary-voltage',
    precision: 2,
  },
  Nominal: {
    label: 'fields.asset.circuit-breaker.nominal',
    precision: 2,
  },
  PorcentagemComponenteCorrenteContinua: {
    label: 'fields.asset.circuit-breaker.continuous-chain',
    precision: 1,
  },
  TensaoAplicada1Min: {
    label: 'fields.asset.circuit-breaker.applied-voltage',
    precision: 2,
  },
  TensaoAplicada: {
    label: 'fields.asset.circuit-breaker.applied-voltage',
    precision: 2,
  },
  ImpulsoAtmosferico: {
    label: 'fields.asset.circuit-breaker.atmospheric-impulse',
    precision: 2,
  },
  FrequenciaIndustrial: {
    label: 'fields.asset.circuit-breaker.industrial-frequency',
    precision: 2,
  },
  VolumeOleo: {
    label: 'fields.asset.transformer.oil-volume',
    precision: 1,
  },
  MassaOleoQuilos: {
    label: 'fields.asset.transformer.oil-mass',
    precision: 1,
  },
  MassaTanque: {
    label: 'fields.asset.transformer.tank-mass-and-accessories',
    precision: 1,
  },
  MassaParteAtiva: {
    label: 'fields.asset.transformer.mass-active-part',
    precision: 1,
  },
  PesoTotal: {
    label: 'fields.asset.transformer.total-weight',
    precision: 1,
  },
};
